import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_Flag = _resolveComponent("Flag")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_Indicator = _resolveComponent("Indicator")!
  const _component_Logo = _resolveComponent("Logo")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "pa-0" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, {
        class: _normalizeClass(["card-location", { selected: _ctx.selected, dashed: _ctx.dashed, disabled: _ctx.disabled }])
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { class: "ma-0" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                class: "pa-0",
                cols: "8"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { class: "ma-0 no-text-wrap token-text-mediumbold" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Icon, {
                        icon: "location",
                        color: _ctx.colorIcon,
                        class: "mr-2 ml-0"
                      }, null, 8, ["color"]),
                      _cache[0] || (_cache[0] = _createTextVNode(" Hosting area "))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, { class: "ma-0 no-text-wrap token-text-regular" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Flag, {
                        code: _ctx.location.attributes.country,
                        class: "mr-2 ml-0"
                      }, null, 8, ["code"]),
                      _createTextVNode(" " + _toDisplayString(_ctx.$helpers.providers.locationToDisplayName(_ctx.location)), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { class: "pa-0" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { class: "ma-0 no-text-wrap token-text-mediumbold" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Icon, {
                        icon: "gpu",
                        color: _ctx.colorIcon,
                        class: "mr-2 ml-0"
                      }, null, 8, ["color"]),
                      _cache[1] || (_cache[1] = _createTextVNode(" Has GPUs "))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, { class: "ma-0 no-text-wrap token-text-regular" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Indicator, {
                        state: _ctx.hasGPU ? 'success' : 'neutral',
                        class: "mr-2 ml-0"
                      }, null, 8, ["state"]),
                      _createTextVNode(" " + _toDisplayString(_ctx.hasGPU ? "Yes" : "No"), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, { class: "ma-0" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                class: "pa-0",
                cols: "8"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { class: "ma-0 no-text-wrap token-text-mediumbold" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Icon, {
                        icon: "publish",
                        color: _ctx.colorIcon,
                        class: "mr-2 ml-0"
                      }, null, 8, ["color"]),
                      _cache[2] || (_cache[2] = _createTextVNode(" Provider "))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, { class: "ma-0 no-text-wrap token-text-regular fit-content" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Logo, {
                        class: "mr-2",
                        logo: _ctx.location.attributes.provider
                      }, null, 8, ["logo"]),
                      _createElementVNode("span", null, _toDisplayString(_ctx.providerLabel), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { class: "pa-0" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { class: "ma-0 no-text-wrap token-text-mediumbold" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Icon, {
                        icon: "credit-card",
                        color: _ctx.colorIcon,
                        class: "mr-2 ml-0"
                      }, null, 8, ["color"]),
                      _cache[3] || (_cache[3] = _createTextVNode(" Price "))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, { class: "ma-0 no-text-wrap token-text-regular" }, {
                    default: _withCtx(() => [
                      (_ctx.minPrice.includes('Infinity') || _ctx.minPrice.includes('NaN'))
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode("-")
                          ], 64))
                        : (_ctx.minPrice)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode("From " + _toDisplayString(_ctx.minPrice), 1)
                            ], 64))
                          : (_openBlock(), _createBlock(_component_Spinner, { key: 2 }))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    _: 1
  }))
}